export enum LogCategory {
    auth = 'auth',
    partner = 'partner',
    sms = 'sms',
    whatsapp = 'whatsapp',
    email = 'email',
    user = 'user',
    contact = 'contact',
    job = 'job',
    webhook = 'webhook',
    stripe = 'stripe',
    callr = 'callr',
    notifications = 'notifications',
    numbers = 'numbers',
    subscription = 'subscription',
    zapier = 'zapier',
    slack = 'slack',
    integration = 'integration',
    prompt = 'prompt',
    security = 'security',
    loginasuser = 'loginasuser',
    sentry = 'sentry',
    plans = 'plans',
    cron = 'cron',
    algolia = 'algolia',
    posthog = 'posthog',
    demo = 'demo',
    voip = 'voip',
    cost = 'cost',
    mcp = 'mcp',
    leedbucks = 'leedbucks',
}

export const logCategoryAsString = (logCategory: LogCategory): string => {
    switch (logCategory) {
        case LogCategory.auth:
            return "🔐 Authentification";
        case LogCategory.partner:
            return "🤝 Partenaire";
        case LogCategory.user:
            return '👤 Utilisateur'
        case LogCategory.contact:
            return '📄 Contact'
        case LogCategory.sms:
            return "💬 SMS";
        case LogCategory.whatsapp:
            return "💬 WhatsApp";
        case LogCategory.email:
            return "✉️ Email";
        case LogCategory.job:
            return "📅 Job";
        case LogCategory.webhook:
            return "🔄 Webhook";
        case LogCategory.stripe:
            return "💵 Stripe";
        case LogCategory.callr:
            return "📞 Callr"
        case LogCategory.notifications:
            return "🔔 Notifications"
        case LogCategory.numbers:
            return "🔢 Numéros"
        case LogCategory.subscription:
            return "🔒 Abonnement"
        case LogCategory.zapier:
            return "🔗 Zapier"
        case LogCategory.slack:
            return "💬 Slack"
        case LogCategory.integration:
            return "🔄 Intégration"
        case LogCategory.prompt:
            return "🤖 Prompt"
        case LogCategory.security:
            return "🔒 Sécurité"
        case LogCategory.loginasuser:
            return "🎭 Login as user"
        case LogCategory.sentry:
            return "🎥 Sentry"
        case LogCategory.plans:
            return "💰 Plans"
        case LogCategory.posthog:
            return "📊 PostHog"
        case LogCategory.demo:
            return "🎬 Demo"
        case LogCategory.voip:
            return "📞 VoIP"
        case LogCategory.cost:
            return "💰 Coût"
        case LogCategory.mcp:
            return "🔌 MCP"
        case LogCategory.leedbucks:
            return "🪙 Leedbucks"
        default:
            return logCategory;
    }
};